import { browserHistory } from 'react-router';

// let _next;
// if (__CLIENT__) {
//   _next = browserHistory.getCurrentLocation().query.next;
//   browserHistory.listen(loc => (_next = loc.query.next));
// }

export function getNext({ isNext = false } = {}) {
  if (!__CLIENT__) {
    return null;
  }
  const location = browserHistory.getCurrentLocation();
  const next = isNext ? `${location.pathname}` : location.query.next;
  return /^\//.test(next) ? next : null;
}

function withNext(path, opts) {
  const next = getNext(opts);
  return next ? `${path}?next=${next}` : path;
}

export function authFacebook(opts) {
  return withNext('/api/auth/facebook', opts);
}

export function authLocal({ existingUser, ...opts } = {}) {
  return existingUser ? getLoginPath(opts) : getSignupPath(opts);
}

export function getSignupPath(opts) {
  return withNext('/signup', opts);
}

export function getLoginPath(opts) {
  return withNext('/login', opts);
}

export function getSubscriptionPath(opts) {
  return withNext('/profile/subscription', opts);
}

export function getProfilePath(opts) {
  return withNext('/profile', opts);
}

export function userFlowNext({ user, subscriber, existingUser, ...opts }) {
  if (!user) {
    return existingUser ? getLoginPath(opts) : getSignupPath(opts);
  }
  if (!subscriber) {
    return getSubscriptionPath(opts);
  }
  return getNext(opts) || getProfilePath(opts);
}

export function toUserFlowNext(props) {
  if (props.user) {
    browserHistory.replace(userFlowNext(props));
  }
}
